module.exports = __webpack_public_path__ + "static/individual-support-room2-32e1ccaa76c8282b425110510203a0f6.png";